// 지원되는 비디오 MIME 타입
export var supportedVideoTypes = [
    'video/mp4',
    'video/webm',
    'video/ogg',
    'video/quicktime'
];
// 지원되는 비디오 확장자
export var supportedVideoExtensions = [
    '.mp4',
    '.webm',
    '.ogg',
    '.mov',
    '.m4v'
];
/**
 * 유효한 미디어 항목 필터링 함수
 * 표시 가능한 미디어만 필터링하여 반환
 * 
 * @param media 전체 미디어 배열
 * @returns 표시 가능한 미디어 배열
 */ export var filterDisplayableMedia = function(media) {
    return media.filter(function(item) {
        return item.url && !(item.type === 'video' && (item.status === 'processing' || item.status === 'error'));
    });
};
/**
 * 처리 중이거나 오류 상태인 미디어 항목 필터링 함수
 * 
 * @param media 전체 미디어 배열
 * @returns 처리 중이거나 오류 상태인 미디어 배열
 */ export var filterProcessingOrErrorMedia = function(media) {
    return media.filter(function(item) {
        return item.status === 'processing' || item.status === 'error';
    });
};
/**
 * 미디어 아이템의 숏폼 여부 확인 함수
 * 세로 형태 비디오인지 확인
 * 
 * @param item 미디어 아이템
 * @returns 숏폼 여부
 */ export var isShortFormVideo = function(item) {
    return item.type === 'video' && !!item.width && !!item.height && item.height > item.width;
};
/**
 * URL에서 파일 확장자 추출 함수
 * 
 * @param url 파일 URL
 * @returns 파일 확장자 (예: '.mp4')
 */ export var getFileExtension = function(url) {
    if (!url) return '';
    // 쿼리 파라미터 제거
    var baseUrl = url.split('?')[0];
    // 마지막 '.' 이후의 문자열 추출
    var extension = baseUrl.substring(baseUrl.lastIndexOf('.'));
    return extension.toLowerCase();
};
/**
 * 미디어 타입이 지원되는 비디오인지 확인
 * 
 * @param item 미디어 아이템 또는 MIME 타입
 * @returns 지원 여부
 */ export var isSupportedVideoType = function(item) {
    if (typeof item === 'string') {
        // MIME 타입이 직접 전달된 경우
        return supportedVideoTypes.includes(item);
    }
    // Media 객체가 전달된 경우
    if (item.type && item.type.startsWith('video/')) {
        return supportedVideoTypes.includes(item.type);
    }
    // URL에서 확장자 확인
    if (item.url) {
        var extension = getFileExtension(item.url);
        return supportedVideoExtensions.includes(extension);
    }
    return false;
};
